"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/context/AuthProvider";
import { UserType } from "@/types/auth";
import Loading from "./loading";

const RootPage = () => {
	const router = useRouter();
	const { role } = useAuth();

	useEffect(() => {
		if (role) {
			// User is logged in, redirect to their home
			if (role === UserType.Admin) {
				router.push("/admin/operator-list");
			} else if (role === UserType.Agent) {
				router.push("/agent/home");
			} else if (role === UserType.Operator) {
				router.push("/operator/home");
			} else if (role === UserType.OperatorSupport) {
				router.push("/support/spin-order-summary");
			} else if (role === UserType.OperatorSupportDev) {
				router.push("/support/home");
			}
		} else {
			// User is not logged in, redirect to login
			router.push("/login");
		}
	}, [role, router]);

	// Nothing to show here: a loader stands in for the redirect.
	return <Loading />;
};

export default RootPage;
